module.exports = __webpack_public_path__ + "static/media/5DPO14.c59caaf5.jpg";